<template>
  <div>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
    <v-layout wrap v-else-if="results">
      <v-flex xs12 md6>
        <v-list>
          <v-list-item @click="()=>{}">
            <v-list-item-title>Posted Loads</v-list-item-title>
            <v-list-item-action>{{results.totalCount.toLocaleString()}}</v-list-item-action>
          </v-list-item>
          <v-list-item @click="()=>{}">
            <v-list-item-title>Posted Loads To Bids</v-list-item-title>
            <v-list-item-action>
              {{results.totalBidsCount.toLocaleString()}}
            </v-list-item-action>
          </v-list-item>
          <v-list-item @click="()=>{}">
            <v-list-item-title>Bids To Loads</v-list-item-title>
            <v-list-item-action>
              {{results.loads.length.toLocaleString()}}
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-flex>
      <v-flex xs12 md6>
        <v-list>
          <v-list-item>
            <v-list-item-title><h2>Loads List</h2></v-list-item-title>
          </v-list-item>
          <v-list-item v-for="item in results.loads" :key="'loads' + item.id" @click="$root.onShowLoadPreview(item.id)">
            <v-list-item-content>
              <v-list-item-title>#{{item.id}}&nbsp;{{item.title}}</v-list-item-title>
              <v-list-item-subtitle>{{item.startedPST}} - {{item.endedPST}}</v-list-item-subtitle>
              <v-list-subtitle>{{item.dispatcherName}}</v-list-subtitle>
            </v-list-item-content>
            <v-list-item-action>${{item.Rate}}</v-list-item-action>
          </v-list-item>

          <!--<v-list-group>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Posted Loads Truck Sizes</v-list-item-title>
                <div class="text-no-wrap">
                  <v-list-item-action v-if="results.totalCountByTruckType.length > 0" class="ma-1">
                    <v-chip small color="success">{{results.totalCountByTruckType[0].truck}}: {{results.totalCountByTruckType[0].count.toLocaleString()}}</v-chip>
                  </v-list-item-action>
                  <v-list-item-action class="ma-1">
                    <v-chip small>Total Types: {{results.totalCountByTruckType.length.toLocaleString()}}</v-chip>
                  </v-list-item-action>
                </div>
              </v-list-item-content>
            </template>

            <v-list-group sub-group v-for="item in results.totalCountByTruckType" :key="'totalCountByTruckType' + item.truck" @click="()=>{}">
              <template v-slot:activator>
                <v-list-item-title>{{item.truck}}</v-list-item-title>
                <v-list-item-action>{{item.count.toLocaleString()}}</v-list-item-action>
              </template>
              <template v-if="results.totalCountByTruckTypeAndState && results.totalCountByTruckTypeAndState.hasOwnProperty(item.truck)">
                <v-list-item v-for="type in ['totalCountByPickupState','totalCountByDeliveryState','totalBidCountByPickupState', 'totalBidCountByDeliveryState']">
                  <v-list-item-content>
                    <v-list-item-title v-if="type==='totalCountByPickupState'">Pickup States</v-list-item-title>
                    <v-list-item-title v-if="type==='totalCountByDeliveryState'">Delivery States</v-list-item-title>
                    <v-list-item-title v-if="type==='totalBidCountByPickupState'">Bids by Pickup State</v-list-item-title>
                    <v-list-item-title v-if="type==='totalBidCountByDeliveryState'">Bids by Delivery State</v-list-item-title>
                    <v-slide-group show-arrows="">
                      <v-slide-item v-for="state in results.totalCountByTruckTypeAndState[item.truck][type]"
                                    :key="type + item.truck + state.state">
                        <v-chip small color="success">{{state.state}}: {{state.count.toLocaleString()}}</v-chip>
                      </v-slide-item>
                    </v-slide-group>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-group>
          </v-list-group>-->

          <!--<v-list-group>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Posted Loads to Bids Truck Sizes</v-list-item-title>
                <div class="text-no-wrap">
                  <v-list-item-action v-if="results.totalBidCountByTruckType.length > 0" class="ma-1">
                    <v-chip small color="success">{{results.totalBidCountByTruckType[0].truck}}: {{results.totalBidCountByTruckType[0].count.toLocaleString()}}</v-chip>
                  </v-list-item-action>
                  <v-list-item-action class="ma-1">
                    <v-chip small>Total Types: {{results.totalBidCountByTruckType.length.toLocaleString()}}</v-chip>
                  </v-list-item-action>
                </div>
              </v-list-item-content>
            </template>

            <v-list-item v-for="item in results.totalBidCountByTruckType" :key="'totalBidCountByTruckType' + item.truck" @click="()=>{}">
              <v-list-item-title>{{item.truck}}</v-list-item-title>
              <v-list-item-action>{{item.count.toLocaleString()}}</v-list-item-action>
            </v-list-item>
          </v-list-group>-->

          <!--

          <v-list-group>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Posted Loads To Bids by Pickup State</v-list-item-title>
                <div class="text-no-wrap">
                  <v-list-item-action v-if="results.totalBidCountByPickupState.length > 0" class="ma-1">
                    <v-chip small color="success">{{results.totalBidCountByPickupState[0].state}}: {{results.totalBidCountByPickupState[0].count.toLocaleString()}}</v-chip>
                  </v-list-item-action>
                  <v-list-item-action v-if="results.totalBidCountByPickupState.length > 1" class="ma-1">
                    <v-chip small color="success">{{results.totalBidCountByPickupState[1].state}}: {{results.totalBidCountByPickupState[1].count.toLocaleString()}}</v-chip>
                  </v-list-item-action>
                  <v-list-item-action v-if="results.totalBidCountByPickupState.length > 2" class="ma-1">
                    <v-chip small color="success">{{results.totalBidCountByPickupState[2].state}}: {{results.totalBidCountByPickupState[2].count.toLocaleString()}}</v-chip>
                  </v-list-item-action>
                  <v-list-item-action class="ma-1">
                    <v-chip small>Total States: {{results.totalBidCountByPickupState.length.toLocaleString()}}</v-chip>
                  </v-list-item-action>
                </div>
              </v-list-item-content>
            </template>

            <v-list-item v-for="item in results.totalBidCountByPickupState" :key="'totalBidCountByPickupState' + item.state" @click="()=>{}">
              <v-list-item-title>{{item.state}}</v-list-item-title>
              <v-list-item-action>{{item.count.toLocaleString()}}</v-list-item-action>
            </v-list-item>
          </v-list-group>

          <v-list-group>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Posted Loads To Bids by Delivery State</v-list-item-title>
                <div class="text-no-wrap">
                  <v-list-item-action v-if="results.totalBidCountByDeliveryState.length > 0" class="ma-1">
                    <v-chip small color="success">{{results.totalBidCountByDeliveryState[0].state}}: {{results.totalBidCountByDeliveryState[0].count.toLocaleString()}}</v-chip>
                  </v-list-item-action>
                  <v-list-item-action v-if="results.totalBidCountByDeliveryState.length > 1" class="ma-1">
                    <v-chip small color="success">{{results.totalBidCountByDeliveryState[1].state}}: {{results.totalBidCountByDeliveryState[1].count.toLocaleString()}}</v-chip>
                  </v-list-item-action>
                  <v-list-item-action v-if="results.totalBidCountByDeliveryState.length > 2" class="ma-1">
                    <v-chip small color="success">{{results.totalBidCountByDeliveryState[2].state}}: {{results.totalBidCountByDeliveryState[2].count.toLocaleString()}}</v-chip>
                  </v-list-item-action>
                  <v-list-item-action class="ma-1">
                    <v-chip small>Total States: {{results.totalBidCountByDeliveryState.length.toLocaleString()}}</v-chip>
                  </v-list-item-action>
                </div>
              </v-list-item-content>
            </template>

            <v-list-item v-for="item in results.totalBidCountByDeliveryState" :key="'totalBidCountByDeliveryState' + item.state" @click="()=>{}">
              <v-list-item-title>{{item.state}}</v-list-item-title>
              <v-list-item-action>{{item.count.toLocaleString()}}</v-list-item-action>
            </v-list-item>
          </v-list-group>-->
        </v-list>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 md4>
        <v-list-item>
          <v-list-item-title>
            <h2 v-if="stateStatType === 'totalCountByPickupState'">Pickup States</h2>
            <h2 v-if="stateStatType === 'totalCountByDeliveryState'">Delivery States</h2>
          </v-list-item-title><v-list-item-action>
          <v-btn small @click="stateStatType = 'totalCountByPickupState';">
            <v-icon small :color="$root.pickupColor">fa-people-carry</v-icon>
          </v-btn>
        </v-list-item-action>
          <v-list-item-action>
            <v-btn small @click="stateStatType = 'totalCountByDeliveryState';">
              <v-icon small :color="$root.deliveryColor">fa-truck-loading</v-icon>
            </v-btn>
          </v-list-item-action>

        </v-list-item>
        <div style="max-height:500px; overflow-y: auto;" v-if="results">
          <template v-for="item in results[stateStatType]">
            <v-list-item :key="stateStatType + item.state" @click="()=>{}">
              <v-list-item-title>{{item.state}}</v-list-item-title>
              <v-list-item-action>{{item.count.toLocaleString()}}</v-list-item-action>
              <v-list-item-action>{{calcPercent(results.totalCount, item.count)}}%</v-list-item-action>
            </v-list-item>
            <v-divider :key="stateStatType + 'Divider' + item.state"/>
          </template>
        </div>
      </v-flex>
      <!--<v-flex xs12 md6 lg4 xl3>
        <v-list-item>
          <v-list-item-title><h2>Delivery States</h2></v-list-item-title>
        </v-list-item>
        <div  style="max-height:500px; overflow-y: auto;">
          <template v-for="item in results.totalCountByDeliveryState">
            <v-list-item :key="'totalCountByDeliveryState' + item.state" @click="()=>{}">
              <v-list-item-title>{{item.state}}</v-list-item-title>
              <v-list-item-action>{{item.count.toLocaleString()}}</v-list-item-action>
              <v-list-item-action>{{calcPercent(results.totalCount, item.count)}}%</v-list-item-action>
            </v-list-item>
            <v-divider :key="'totalCountByDeliveryStateDivider' + item.state"/>
          </template>
        </div>
      </v-flex>-->
      <v-flex xs12 md8>
        <v-list-item>
          <v-list-item-action v-if="selectedTruckType !== ''">
            <v-btn icon
                   @click="selectedTruckType !== '' ? selectedTruckType='': null">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-title>
            <h2 v-if="selectedTruckType !== ''">
              {{selectedTruckType}}
              <v-btn small @click="truckStatType = 'totalCountByPickupState';" class="ma-1">
                <v-icon small :color="$root.pickupColor">fa-people-carry</v-icon>
              </v-btn>
              <v-btn small @click="truckStatType = 'totalCountByDeliveryState';" class="ma-1">
                <v-icon small :color="$root.deliveryColor">fa-truck-loading</v-icon>
              </v-btn>
            </h2>
            <h2 v-else>Posted Loads Truck Sizes</h2>
          </v-list-item-title>
        </v-list-item>
        <div  style="max-height:500px; overflow-y: auto;">
          <template v-if="selectedTruckType === '' && results">
            <template v-for="item in results.totalCountByTruckType">
              <v-list-item :key="'totalCountByTruckType' + item.truck" @click="() => {selectedTruckType=item.truck; selectedTruckTypeCount=item.count;}">
                <v-list-item-title>{{item.truck}}</v-list-item-title>
                <v-list-item-action>{{item.count.toLocaleString()}}</v-list-item-action>
                <v-list-item-action>{{calcPercent(results.totalCount, item.count)}}%</v-list-item-action>
              </v-list-item>
              <v-divider :key="'totalCountByTruckTypeDivider' + item.truck"/>
            </template>
          </template>
          <template v-else>
            <template v-if="results && results.hasOwnProperty('totalCountByTruckTypeAndState') && results.totalCountByTruckTypeAndState.hasOwnProperty(selectedTruckType)">
              <v-list-item>
                <v-layout wrap>
                  <template v-for="type in ['totalCountByPickupState', 'totalCountByDeliveryState', 'totalBidCountByPickupState', 'totalBidCountByDeliveryState']">
                    <v-flex xs6
                            :key="type"
                            v-if="(truckStatType === 'totalCountByPickupState' && (type === 'totalBidCountByPickupState' || type === 'totalCountByPickupState')) ||
                                   (truckStatType === 'totalCountByDeliveryState' && (type === 'totalBidCountByDeliveryState' || type === 'totalCountByDeliveryState'))">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title v-if="type==='totalCountByPickupState'"><h4>Pickup States</h4></v-list-item-title>
                          <v-list-item-title v-if="type==='totalCountByDeliveryState'"><h4>Delivery States</h4></v-list-item-title>
                          <v-list-item-title v-if="type==='totalBidCountByPickupState'"><h4>Bids by Pickup State</h4></v-list-item-title>
                          <v-list-item-title v-if="type==='totalBidCountByDeliveryState'"><h4>Bids by Delivery State</h4></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="results.totalCountByTruckTypeAndState[selectedTruckType][type] && results.totalCountByTruckTypeAndState[selectedTruckType][type].length === 0" :key="type + selectedTruckType">
                        <v-list-item-title>Empty</v-list-item-title>
                      </v-list-item>
                      <template v-for="state in results.totalCountByTruckTypeAndState[selectedTruckType][type]">
                        <v-list-item :key="type + selectedTruckType + state.state"  @click="()=>{}">
                          <v-list-item-title>{{state.state}}</v-list-item-title>
                          <v-list-item-action>{{state.count.toLocaleString()}}</v-list-item-action>
                          <v-list-item-action>{{calcPercent(selectedTruckTypeCount, state.count)}}%</v-list-item-action>
                        </v-list-item>
                        <v-divider :key="'divider_' + type + selectedTruckType + state.state"/>
                      </template>
                    </v-flex>
                  </template>
                </v-layout>
              </v-list-item>
            </template>
          </template>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import reportsMixin from '../../mixins/reportsMixin.js';
export default {
  name: 'LoadsFeedReport',
  props: ['to', 'from'],
  mixins: [ reportsMixin ],
  components: {
  },
  data: function () {
    return {
      loading: false,
      results: null,
      stateStatType: 'totalCountByPickupState',
      truckStatType: 'totalCountByPickupState',
      selectedTruckType: '',
      selectedTruckTypeCount: 0
    };
  },
  mounted () {
    this.$nextTick(() => {
      this.fetchData();
    });
  },
  methods: {
    calcPercent (total, part) {
      if (total <= 0) return 0;
      return parseFloat(parseFloat(part / total * 100).toFixed(1));
    },
    fetchData () {
      if (!this.from || !this.to) return;
      this.loading = true;
      this.getLoadsFeedReportData(this.from, this.to).then((response) => {
        if (response.status === 'ok') {
          this.results = response.results;
          this.loading = false;
        }
      }).finally(() => {
        this.loading = false;
      });
    }

  }
};
</script>
